// [file name]: deployment.js
import api from './index'

// 获取部署环境列表
export const getDeploymentEnvironments = (params) => {
  return api.get('/work/deployment/environments', { params })
}

// 创建部署环境
export const createDeploymentEnvironment = (data) => {
  return api.post('/work/deployment/environments', data)
}

// 更新部署环境
export const updateDeploymentEnvironment = (id, data) => {
  return api.put(`/work/deployment/environments/${id}`, data)
}

// 删除部署环境
export const deleteDeploymentEnvironment = (id) => {
  return api.delete(`/work/deployment/environments/${id}`)
}

// 获取环境绑定的用户组
export const getEnvironmentUserGroups = (environmentId) => {
  return api.get(`/work/deployment/environments/${environmentId}/user-groups`)
}

// 绑定用户组到环境
export const bindUserGroupToEnvironment = (environmentId, userGroupIds) => {
  return api.post(`/work/deployment/environments/${environmentId}/bind-user-groups`, { userGroupIds })
}
